module.exports = __webpack_public_path__ + "static/img/3.4b8f02d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/3.png
// module id = 2RKe
// module chunks = 1